module.exports = __webpack_public_path__ + "static/flow4-7f14b81a6b78a3ca9bde9d1dd4081155.svg";